/*
© 2018-present Harald Rudell <harald.rudell@gmail.com> (http://www.haraldrudell.com)
All rights reserved.
*/
import React, {memo, useMemo} from 'react'
import styled, {keyframes, css} from 'styled-components'
import logo from './logo.svg'
import gopher from './gopher-seeklogo.com.svg'
import nodeJs from './Node.js_logo.svg'
import duke from './duke_badge.svg'

const Styling = styled.div`
display: flex;
justify-content: space-between;
height: 128px;
`
const RowSize = css`height: 128px`
export default memo(({animate}) => {
  const props = {css: RowSize, count: animate ? 'infinite' : 1}
  return <Styling>
    <ReactLogo {...props} />
    <GoLogo {...props} />
    <NodeLogo {...props} />
    <JavaLogo {...props} />
  </Styling>})

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
// 6 points: 2 s => 12 s period
const ReactLogo = memo(({css = '', count = 'infinite'}) => {
  const SpinningReact = useMemo(() => styled.img`animation: ${rotate360} ${count} 12s linear;${css}`, [css, count])
  return <SpinningReact src={logo} alt="React logo" />})

const slideUp = keyframes`
{
  0% {
    transform: translateY(256px);
  }
  100% {
    transform: translateY(0);
  }
}`
const Clip = styled.div`overflow: hidden`
const GoLogo = memo(({css = '', count = 'infinite'}) => {
  const SpinningReact = useMemo(() => styled.img`animation: ${slideUp} ease-in-out 2s ${count};${css}`, [css, count])
  return <Clip><SpinningReact src={gopher} alt="Golang logo" /></Clip>})

const heartbeat = keyframes`
{
  0%, 40%, 80%, 100%
  {
    transform: scale(.9);
  }
  20%, 60%
  {
    transform: scale(1);
  }
}`
const NodeLogo = memo(({css = '', count = 'infinite'}) => {
  const SpinningReact = useMemo(() => styled.img`animation: ${heartbeat} ${count} 2s linear;${css}`, [css, count])
  return <SpinningReact src={nodeJs} alt="Node.js logo" />})

const Bounce = keyframes`
{
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}`
const JavaLogo = memo(({css = '', count = 'infinite'}) => {
  const JumpingDuke = useMemo(() => styled.img`animation: ${Bounce} ease-in-out 2s ${count};${css}`, [css, count])
  return <JumpingDuke src={duke} alt="Java duke" />})
